/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DataSourceProvider = "Google" | "Office365" | "%future added value";
export type DataSourceStatus = "Okay" | "RequiresReAuth" | "%future added value";
export type OrgCrawlTest = "GoogleApiAccessDisabled" | "GoogleContactSharingDisabled" | "NoCrawl" | "NoExternalOrganization" | "ShouldCrawl" | "Skipped" | "StartedCrawl" | "%future added value";
export type OnboardingNUX_viewer = {
    readonly outerTeamQueryResultErrorable: {
        readonly query?: string | undefined;
        readonly teams?: ReadonlyArray<{
            readonly teamId: string;
        }> | undefined;
    };
    readonly user: {
        readonly createdTime: unknown | null;
        readonly dataSources: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly state: DataSourceStatus | null;
                    readonly type: DataSourceProvider | null;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly flowStates: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly flowKey: string | null;
                    readonly current: {
                        readonly id: string;
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly pending: {
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly primaryOrgCalendar: string;
                    readonly experiments: ReadonlyArray<string | null> | null;
                    readonly crawlTest: OrgCrawlTest | null;
                    readonly userTeams: {
                        readonly __typename: "TeamList";
                        readonly list: ReadonlyArray<{
                            readonly teamId: string;
                        }>;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly " $fragmentRefs": FragmentRefs<"FastCrawlErrorCard_org" | "OnboardingChromeIntro_org" | "OnboardingSurveyStep_org" | "IndividualJtbdSurveyStep_org" | "OnboardingTeamJoinCreateStep_org" | "OnboardingWorkingHoursStep_org" | "OnboardingMeetingHoursStep_org" | "OnboardingLunchStep_org" | "OnboardingFocusTimeSyncAndLunchStep_org" | "OnboardingIntroduceAutopilotStep_org" | "OnboardingLinksStep_org" | "OnboardingFocusTimeSyncStep_org" | "OnboardingPrivateCalendarSyncStep_org" | "OnboardingTravelTimeStep_org" | "OnboardingSlackStep_org" | "OnboardingSummaryStep_org" | "OnboardingIntroduceFocusTimeStep_org" | "OnboardingAutopilotStepRenderer_org" | "OnboardingInviteStep_org" | "OnboardingColorCodingStep_org" | "OnboardingScheduleTestEventStepRenderer_org" | "OnboardingFlexMeetingStepRenderer_org">;
                } | null;
            } | null> | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"OnboardingChromeIntro_user" | "OnboardingFocusTimeSyncAndLunchStep_user" | "OnboardingIntroduceFocusTimeStep_user" | "OnboardingScheduleTestEventStepRenderer_user" | "OnboardingAutopilotStepRenderer_user" | "OnboardingColorCodingStep_user" | "OnboardingPrivateCalendarSyncStep_user" | "OnboardingSummaryStep_user" | "OnboardingFlexMeetingStepRenderer_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"WebAppNavAvatarMenu_viewer" | "OnboardingInviteStep_viewer" | "OnboardingTeamJoinCreateStep_viewer">;
    readonly " $refType": "OnboardingNUX_viewer";
};
export type OnboardingNUX_viewer$data = OnboardingNUX_viewer;
export type OnboardingNUX_viewer$key = {
    readonly " $data"?: OnboardingNUX_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingNUX_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamId",
            "storageKey": null
        } as any
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentComplete",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
    } as any, v7 = [
        {
            "kind": "Variable",
            "name": "week",
            "variableName": "week"
        } as any
    ], v8 = [
        {
            "kind": "Variable",
            "name": "timeZone",
            "variableName": "timeZone"
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "myCalendarIds"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgRelayId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "week"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingNUX_viewer",
        "selections": [
            {
                "alias": "outerTeamQueryResultErrorable",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "excludeMyTeams",
                        "value": false
                    },
                    (v0 /*: any*/),
                    {
                        "kind": "Literal",
                        "name": "query",
                        "value": ""
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamQueryResultErrorable",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "query",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "teams",
                                "plural": true,
                                "selections": (v1 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "type": "TeamQueryResult",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdTime",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": "DataSourceConnection",
                        "kind": "LinkedField",
                        "name": "dataSources",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DataSourceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DataSource",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            (v4 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "type",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "name",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "dataSources(first:1000000)"
                    },
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": "FlowStateConnection",
                        "kind": "LinkedField",
                        "name": "flowStates",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FlowState",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "flowKey",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FlowStatus",
                                                "kind": "LinkedField",
                                                "name": "current",
                                                "plural": false,
                                                "selections": [
                                                    (v3 /*: any*/),
                                                    (v4 /*: any*/),
                                                    (v5 /*: any*/),
                                                    (v6 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FlowStatus",
                                                "kind": "LinkedField",
                                                "name": "pending",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    (v5 /*: any*/),
                                                    (v6 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "flowStates(first:1000000)"
                    },
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryOrgCalendar",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "experiments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "crawlTest",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "userTeams",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "__typename",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Team",
                                                                "kind": "LinkedField",
                                                                "name": "list",
                                                                "plural": true,
                                                                "selections": (v1 /*: any*/),
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "TeamList",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FastCrawlErrorCard_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingChromeIntro_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingSurveyStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "IndividualJtbdSurveyStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingTeamJoinCreateStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingWorkingHoursStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingMeetingHoursStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingLunchStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingFocusTimeSyncAndLunchStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingIntroduceAutopilotStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingLinksStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingFocusTimeSyncStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingPrivateCalendarSyncStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingTravelTimeStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingSlackStep_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingSummaryStep_org"
                                            },
                                            {
                                                "args": (v7 /*: any*/),
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingIntroduceFocusTimeStep_org"
                                            },
                                            {
                                                "args": (v8 /*: any*/),
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingAutopilotStepRenderer_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingInviteStep_org"
                                            },
                                            {
                                                "args": (v7 /*: any*/),
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingColorCodingStep_org"
                                            },
                                            {
                                                "args": (v7 /*: any*/),
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingScheduleTestEventStepRenderer_org"
                                            },
                                            {
                                                "args": (v8 /*: any*/),
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingFlexMeetingStepRenderer_org"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingChromeIntro_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingFocusTimeSyncAndLunchStep_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingIntroduceFocusTimeStep_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingScheduleTestEventStepRenderer_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingAutopilotStepRenderer_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingColorCodingStep_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingPrivateCalendarSyncStep_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingSummaryStep_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnboardingFlexMeetingStepRenderer_user"
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WebAppNavAvatarMenu_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OnboardingInviteStep_viewer"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "myCalendarIds",
                        "variableName": "myCalendarIds"
                    },
                    (v0 /*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "OnboardingTeamJoinCreateStep_viewer"
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '3739a73a802d535a07418a038dcfd3cb';
export default node;
